var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('product-template',{attrs:{"product":_vm.box,"likes":[],"oneShot":_vm.oneShot,"initQuantity":_vm.quantity,"inCart":true,"isBox":true,"status":_vm.PRODUCT_STATUS.readonly,"showFreq":false,"withLikes":false}})}
var staticRenderFns = []

export { render, staticRenderFns }